import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

// Statically import the language-specific components for better SEO.
import ProviderTermsOfUseEN from './en/ProviderTermsOfUse';
import ProviderTermsOfUseHE from './he/ProviderTermsOfUse';

const ProviderTermsOfUse = () => {
  const lang = useLanguage();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = ProviderTermsOfUseHE;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = ProviderTermsOfUseEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default ProviderTermsOfUse;
